var exports = {
  "kL": "ReportFlowScreenView.module__container___c2Jkcz",
  "uW": "ReportFlowScreenView.module__section___c2Jkcz",
  "R_": "ReportFlowScreenView.module__heading___c2Jkcz",
};

module.exports = exports;
